<!-- Main container for the whole component -->
<div class="workflow-container p-4">
  <!-- ===== MI STEPPER BLOCK ===== -->
  <div *ngIf="miApplications.length > 0 && miSelectedApplication" class="stepper-section">
    <div class="flex align-items-center justify-content-between mb-4">
      <h3 class="text-xl font-semibold text-gray-700 m-0">MI Workflow Track</h3>
      
        <button pButton 
              label="View MI Default Flow" 
              icon="pi pi-info-circle" 
              class="p-button-sm p-button-outlined p-button-rounded"
              (click)="openDefaultFlowDialog('MI')">
        </button>
    </div>
    
    <div class="stepper-rows fancy-card">
      <ng-container *ngFor="let row of miStepRows; let r = index; trackBy: trackByIndex">
        <div class="stepper-row" [class.rtl]="isRTLRow(r)" role="group" [attr.aria-label]="'Row ' + (r + 1)">

          <!-- L→R rows: For even rows -->
          <ng-container *ngIf="r % 2 === 0; else rtlRowMi">
            <div class="step"
                 *ngFor="let action of row; let i = index; trackBy: trackByIndex"
                 role="button" tabindex="0"
                 [attr.data-globalIndex]="r * cols + i"
                 (click)="goToMiStep(r * cols + i)"> <!-- Use goToMiStep -->

              <div class="circle" [ngClass]="statusClass(action.status)">
                <img class="status-icon"
                     [src]="getStatusIconUrl(action.status)"
                     [alt]="getStatusText(action.status)" />
              </div>

              <div class="label">{{ action.name }}</div>
              <div class="status-line date-line">
                <span class="txt">{{ getActionDate(action.raw) | date:'MMM d, y, h:mm a' }}</span>
              </div>

              <!-- Use miSelectedApplication for connector logic -->
              <div class="line" *ngIf="showStraight(r * cols + i, miSelectedApplication.actions.length)"></div>
              <ng-container *ngIf="showBend(r * cols + i, miSelectedApplication.actions.length)">
                <div class="bend-right"></div>
                <div class="cap-right"></div>
              </ng-container>
            </div>
          </ng-container>

          <!-- R→L rows: For odd rows -->
          <ng-template #rtlRowMi>
            <div class="spacer" *ngFor="let _ of range(cols - row.length)"></div>
            <div class="step"
                 *ngFor="let action of row; let i = index; trackBy: trackByIndex"
                 role="button" tabindex="0"
                 [attr.data-globalIndex]="r * cols + (row.length - 1 - i)"
                 (click)="goToMiStep(r * cols + (row.length - 1 - i))"> <!-- Use goToMiStep -->

              <ng-container *ngIf="row[row.length - 1 - i] as revAction">
                <div class="circle" [ngClass]="statusClass(revAction.status)">
                  <img class="status-icon"
                       [src]="getStatusIconUrl(revAction.status)"
                       [alt]="getStatusText(revAction.status)" />
                </div>

                <div class="label">{{ revAction.name }}</div>
                <div class="status-line date-line">
                  <span class="txt">{{ getActionDate(revAction.raw) | date:'MMM d, y, h:mm a' }}</span>
                </div>

                <!-- Use miSelectedApplication for connector logic -->
                <div class="line" *ngIf="showStraight(r * cols + (row.length - 1 - i), miSelectedApplication.actions.length)"></div>
                <ng-container *ngIf="showBend(r * cols + (row.length - 1 - i), miSelectedApplication.actions.length)">
                  <div class="bend-left"></div>
                  <div class="cap-left"></div>
                </ng-container>
              </ng-container>
            </div>
          </ng-template>

        </div>
      </ng-container>
    </div>
  </div> 

 <!-- ===== POND STEPPER BLOCK ===== -->
  <div *ngIf="pondApplications.length > 0 && pondSelectedApplication" class="stepper-section mb-6">
    <div class="flex align-items-center justify-content-between mb-4">
      <h3 class="text-xl font-semibold text-gray-700 m-0">Tank Workflow Track</h3>
  
       <button pButton 
          label="View POND Default Flow" 
          icon="pi pi-info-circle" 
          class="p-button-sm p-button-outlined p-button-rounded"
          (click)="openDefaultFlowDialog('Pond')">
       </button>
    </div>
    
    <div class="stepper-rows fancy-card">
      <ng-container *ngFor="let row of pondStepRows; let r = index; trackBy: trackByIndex">
        <div class="stepper-row" [class.rtl]="isRTLRow(r)" role="group" [attr.aria-label]="'Row ' + (r + 1)">

          <!-- L→R rows: For even rows -->
          <ng-container *ngIf="r % 2 === 0; else rtlRowPond">
            <div class="step"
                 *ngFor="let action of row; let i = index; trackBy: trackByIndex"
                 role="button" tabindex="0"
                 [attr.data-globalIndex]="r * cols + i"
                 (click)="goToPondStep(r * cols + i)"> 

              <div class="circle" [ngClass]="statusClass(action.status)">
                <img class="status-icon"
                     [src]="getStatusIconUrl(action.status)"
                     [alt]="getStatusText(action.status)" />
              </div>

              <div class="label">{{ action.name }}</div>
              <div class="status-line date-line">
                <span class="txt">{{ getActionDate(action.raw) | date:'MMM d, y, h:mm a' }}</span>
              </div>

              <!-- Use pondSelectedApplication for connector logic -->
              <div class="line" *ngIf="showStraight(r * cols + i, pondSelectedApplication.actions.length)"></div>
              <ng-container *ngIf="showBend(r * cols + i, pondSelectedApplication.actions.length)">
                <div class="bend-right"></div>
                <div class="cap-right"></div>
              </ng-container>
            </div>
          </ng-container>

          <!-- R→L rows: For odd rows -->
          <ng-template #rtlRowPond>
            <div class="spacer" *ngFor="let _ of range(cols - row.length)"></div>
            <div class="step"
                 *ngFor="let action of row; let i = index; trackBy: trackByIndex"
                 role="button" tabindex="0"
                 [attr.data-globalIndex]="r * cols + (row.length - 1 - i)"
                 (click)="goToPondStep(r * cols + (row.length - 1 - i))"> 

              <ng-container *ngIf="row[row.length - 1 - i] as revAction">
                <div class="circle" [ngClass]="statusClass(revAction.status)">
                  <img class="status-icon"
                       [src]="getStatusIconUrl(revAction.status)"
                       [alt]="getStatusText(revAction.status)" />
                </div>

                <div class="label">{{ revAction.name }}</div>
                <div class="status-line date-line">
                  <span class="txt">{{ getActionDate(revAction.raw) | date:'MMM d, y, h:mm a' }}</span>
                </div>

                <!-- Use pondSelectedApplication for connector logic -->
                <div class="line" *ngIf="showStraight(r * cols + (row.length - 1 - i), pondSelectedApplication.actions.length)"></div>
                <ng-container *ngIf="showBend(r * cols + (row.length - 1 - i), pondSelectedApplication.actions.length)">
                  <div class="bend-left"></div>
                  <div class="cap-left"></div>
                </ng-container>
              </ng-container>
            </div>
          </ng-template>

        </div>
      </ng-container>
    </div>
  </div>

  <!-- ===== EMPTY STATE ===== -->
  <div *ngIf="pondApplications.length === 0 && miApplications.length === 0" class="empty-state text-center p-8">
    <i class="pi pi-info-circle text-4xl text-gray-400 mb-4"></i>
    <p class="text-lg text-gray-600">No workflow data found for this application.</p>
  </div>
  <!-- LEGEND  -->
  <div *ngIf="showLegend" class="workflow-legend-container">

    <strong style="margin-right: 1rem;">Legend:</strong>

    <span class="legend-item">
      <span class="legend-color-box" style="background-color: #2E7D32;"></span>
      <span>Approved</span>
    </span>

    <span class="legend-item">
      <span class="legend-color-box" style="background-color: #F9A825;"></span>
      <span>Pending</span>
    </span>

    <span class="legend-item">
      <span class="legend-color-box" style="background-color: #C62828;"></span>
      <span>Rejected</span>
    </span>

    <span class="legend-item">
      <span class="legend-color-box" style="background-color: #EF6C00;"></span>
      <span>Data Required</span>
    </span>

    <span class="legend-item">
      <span class="legend-color-box" style="background-color: #8E24AA;"></span>
      <span>Reply Pending</span>
    </span>
    
    <span class="legend-item">
      <span class="legend-color-box" style="background-color: #90A4AE;"></span>
      <span>Unknown</span>
    </span>

  </div>
  <!-- dialog -->
  <p-dialog [(visible)]="displayDialog" [modal]="true" [closable]="true" [header]="currentActionName" [style]="{width: '400px', height: 'auto'}">
    <div *ngIf="currentActionData" class="p-dialog-content">
    
      <p><strong>AppID:</strong> {{ currentActionData.AppID }}</p>
      <p><strong>Action:</strong> {{ currentActionData.Action }}</p>
      <p><strong>Status:</strong> {{ getStatusText(currentActionData.Status) }} ({{ currentActionData.Status }})</p>
      <p><strong>LevelID:</strong> {{ currentActionData.LevelID }}</p>
      <p><strong>ProgramID:</strong> {{ currentActionData.ProgramID }}</p>
      <p *ngIf="currentActionData.ComponentName"><strong>Component:</strong> {{ currentActionData.ComponentName }}</p>
      <p><strong>AssignDate:</strong> {{ currentActionData.AssignDate ?? '-'| date:'medium' }}</p>
      <p><strong>ActionDate:</strong> {{ currentActionData.ActionDate ?? '-'| date:'medium' }}</p>
      <p><strong>UpdateDate:</strong> {{ currentActionData.UpdateDate ?? '-'| date:'medium' }}</p>
      <p><strong>TargetDays:</strong> {{ currentActionData.TragetDays }}</p>
      <p><strong>Pending/Completed Days:</strong> {{ currentActionData.PendingCompletedDays }}</p>
      <p><strong>UserID:</strong> {{ currentActionData.UserID }}</p>
      <p><strong>NextUser:</strong> {{ currentActionData.NextUser }}</p>
      <p *ngIf="currentActionData.Remarks"><strong>Remarks:</strong> {{ currentActionData.Remarks }}</p>
    </div>

    <p-footer>
      <button type="button" pButton label="Close" icon="pi pi-times" (click)="displayDialog = false" class="p-button p-button-danger" style="width: 100px;"></button>
    </p-footer>
  </p-dialog>

  <!-- ===== DEFAULT STEPPER BLOCK ===== -->
  <p-dialog [(visible)]="displayDefaultDialog" 
            [modal]="true" 
            [style]="{width: '90vw', maxWidth: '1200px'}" 
            [header]="defaultFlowTitle"
            [maximizable]="true"
            [closable]="true">

    <div class="workflow-container p-0">
      <div class="stepper-rows fancy-card" *ngIf="defaultStepRows && defaultStepRows.length > 0">
        
        <ng-container *ngFor="let row of defaultStepRows; let r = index; trackBy: trackByIndex">
          
          <div class="stepper-row" [class.rtl]="isRTLRow(r)">

            <ng-container *ngIf="r % 2 === 0; else rtlDefault">
              <div class="step" 
                  *ngFor="let action of row; let i = index; trackBy: trackByIndex"
                  [attr.data-globalIndex]="r * cols + i">

                <div class="circle" [ngClass]="statusClass(action.status)">
                  <img class="status-icon" 
                        [src]="action.status === 'N' ? 'assets/emojis/unknown.png' : getStatusIconUrl(action.status)" 
                        [alt]="action.status" />
                </div>

                <div class="label">{{ action.name }}</div>
                
                <div class="status-line date-line">
                  <span *ngIf="action.customText" class="txt" style="font-style: italic; color: #888;">
                    {{ action.customText }}
                  </span>
                  <span *ngIf="!action.customText && action.raw" class="txt">
                    {{ getActionDate(action.raw) | date:'MMM d, y, h:mm a' }}
                  </span>
                  <span *ngIf="!action.customText && !action.raw" class="txt" style="min-height: 14px; display:block"></span>
                </div>

                <div class="line" *ngIf="showStraight(r * cols + i, defaultStepsTotalCount)"></div>
                <ng-container *ngIf="showBend(r * cols + i, defaultStepsTotalCount)">
                  <div class="bend-right"></div>
                  <div class="cap-right"></div>
                </ng-container>

              </div>
            </ng-container>

            <ng-template #rtlDefault>
              <div class="spacer" *ngFor="let _ of range(cols - row.length)"></div>

              <div class="step" 
                  *ngFor="let action of row; let i = index; trackBy: trackByIndex"
                  [attr.data-globalIndex]="r * cols + (row.length - 1 - i)">

                <ng-container *ngIf="row[row.length - 1 - i] as revAction">
                  
                  <div class="circle" [ngClass]="statusClass(revAction.status)">
                    <img class="status-icon" 
                        [src]="revAction.status === 'N' ? 'assets/emojis/unknown.png' : getStatusIconUrl(revAction.status)" 
                        [alt]="revAction.status" />
                  </div>

                  <div class="label">{{ revAction.name }}</div>

                  <div class="status-line date-line">
                    <span *ngIf="revAction.customText" class="txt" style="font-style: italic; color: #888;">
                      {{ revAction.customText }}
                    </span>
                    <span *ngIf="!revAction.customText && revAction.raw" class="txt">
                      {{ getActionDate(revAction.raw) | date:'MMM d, y, h:mm a' }}
                    </span>
                    <span *ngIf="!revAction.customText && !revAction.raw" class="txt" style="min-height: 14px; display:block"></span>
                  </div>

                  <div class="line" *ngIf="showStraight(r * cols + (row.length - 1 - i), defaultStepsTotalCount)"></div>
                  <ng-container *ngIf="showBend(r * cols + (row.length - 1 - i), defaultStepsTotalCount)">
                    <div class="bend-left"></div>
                    <div class="cap-left"></div>
                  </ng-container>

                </ng-container>

              </div>
            </ng-template>

          </div>
        </ng-container>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <div style="display: flex; flex-wrap: wrap; gap: 1rem; align-items: center; width: 100%;padding-top: 0.5rem;">
        
        <strong style="margin-right: 1rem;">Legend:</strong>

        <span style="display: flex; align-items: center; gap: 0.4rem;">
          <span style="width: 18px; height: 18px; background-color: #2E7D32; border-radius: 4px; border: 1px solid #0003;"></span>
          <span>Completed Steps</span>
        </span>

        <span style="display: flex; align-items: center; gap: 0.4rem;">
          <span style="width: 18px; height: 18px; background-color: #90A4AE;; border-radius: 4px; border: 1px solid #0003;"></span>
          <span>Pending Steps</span>
        </span>
        </div>
   </ng-template>
  </p-dialog>
</div>

